import React from 'react';
import { motion } from 'framer-motion';
import Credibility from '../assets/Icons/credibility.png';
import CustomerReview from '../assets/Icons/customer-review.png';
import English from '../assets/Icons/english.png';
import Files from '../assets/Icons/files.png';
import Briefcase from '../assets/Icons/briefcase.png';

const features = [
  { icon: Briefcase,      title: 'Experienced',       description: '25+ years in the industry' },
  { icon: English,        title: 'English Speaking',  description: 'Clear communication always' },
  { icon: Files,          title: 'Background Checked', description: 'Thoroughly vetted team' },
  { icon: Credibility,    title: 'Licensed & Insured', description: 'Fully bonded for your protection' },
  { icon: CustomerReview, title: 'Highly Rated',       description: '5-star reviews everywhere' },
];

const stats = [
  { value: '25+',   label: 'Years Experience' },
  { value: '5,000+', label: 'Happy Customers' },
  { value: '100%',  label: 'Satisfaction Rate' },
  { value: '5.0',   label: 'Average Rating' },
];

const Trusters = () => (
  <section className="py-24 bg-white">
    <div className="max-w-7xl mx-auto px-6">

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <span className="inline-block bg-brand-50 text-brand-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
          Why Choose Us
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Trusted Cleaners You Can Count On
        </h2>
        <p className="text-slate-500 max-w-2xl mx-auto leading-relaxed">
          Inviting someone into your home is a big deal. Every Fabiana Fabulous cleaner is carefully vetted so you get the right person caring for your space.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-16">
        {features.map((f, idx) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.08 }}
            className="bg-slate-50 hover:bg-brand-50 border border-slate-100 hover:border-brand-200 rounded-2xl p-6 text-center transition-all duration-300 group"
          >
            <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto mb-4 group-hover:shadow-md transition-shadow">
              <img src={f.icon} alt={f.title} className="w-7 h-7 object-contain" />
            </div>
            <h3 className="text-sm font-semibold text-slate-900 mb-1">{f.title}</h3>
            <p className="text-xs text-slate-500">{f.description}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-brand-600 rounded-3xl p-10"
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-white">
          {stats.map((s, idx) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <div className="text-4xl font-bold mb-1 tracking-tight">{s.value}</div>
              <div className="text-brand-100 text-sm font-medium">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-12 text-center"
      >
        <p className="text-slate-500 mb-6">Ready to experience the difference?</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href="tel:4258296092"
            className="inline-flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white font-semibold px-7 py-3 rounded-xl transition-colors">
            Call (425) 829-6092
          </a>
          <a href="/request"
            className="inline-flex items-center justify-center gap-2 border-2 border-brand-600 text-brand-700 hover:bg-brand-50 font-semibold px-7 py-3 rounded-xl transition-colors">
            Get Free Quote
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Trusters;
